<template>
  <div>
    <v-btn @click="showCreateNoMatchDialog">Create User Ride Type Waiting Time Fee</v-btn>
    <UserRideTypeWaitTimeList 
      @reload="reload" :userRideTypeWaitTimes="user.user_ride_type_wait_times"/>
     <v-dialog
      v-model="dialog"
      max-width='400'
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5f9;">
        <v-card-title>Create Waiting Time Fee</v-card-title>
        <v-flex v-if="loadingEditBooking == true">
          <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
        </v-flex>
          <v-flex pa-2>
        <v-select
            v-model="new_ride_type"
            :items="rideTypes"
            item-text="name"
            item-value="id"
            label="Ride Type"
            @input="resetError('ride_type_id')"
            :disabled="disabled"
          />
          </v-flex>
        <v-flex pa-2>
        <v-currency-field
          v-model="fee"
          type="number"
          v-bind="currency_config"
          min="0"
          class="small-text-field"
          single-line
          height="28"
          flat
        />
        </v-flex>
        <v-flex pa-2>
        <v-text-field type="number" label="Wait Time Kickin (Minutes)" v-model="new_kickin_time_minutes"/>
        </v-flex>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat text @click="dialog = false">Cancel</v-btn>
            <v-btn flat text @click="create()">Create</v-btn>
          </v-card-actions>
          <v-progress-linear v-if="loadingRefund == true" indeterminate color="yellow darken-2"></v-progress-linear>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import UserRideTypeWaitTimeList from "@/components/waiting_time/UserRideTypeWaitTimeList.vue";

import SelectableRideTypeInput from "@/components/widget/input/SelectableRideTypeInput.vue";

export default {
  name: "user_ride_type_wait_time_panel",
  components: {
    UserRideTypeWaitTimeList,
    SelectableRideTypeInput,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    reload: {
      type: Function,
      default: null,
    }
  },
  data: function() {
    return {
      new_ride_type: null,
      new_kickin_time_minutes: 0,
      fee: 0,
      dialog: false,
      loading: false,
      noMatches: [],
      description: "",
      oppositeId: null,
      rideTypes: [],
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
    }
  },
  mounted: function() {
    this.getRideTypes();
  },
  methods: {
    get() {
      this.reload();
    },
    changeRideType() {

    },
    getRideTypes: async function () {
      console.log("test");
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = [];
        this.rideTypes = this.rideTypes.concat(response.data.ride_types);
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
    handleUpdate(id) {
      this.oppositeId = id;
    },
    showCreateNoMatchDialog() {
      this.description = ""
      this.dialog = true;
    },
    async create() {
      this.loading = true;

      var url = "";

      var self = this;

      url = `${this.$store.state.apiUrl}/customer/ride_type_wait_time/create?user_id=${this.user.id}&ride_type_id=${this.new_ride_type}&kickin_time_minutes=${this.new_kickin_time_minutes}&fee=${this.fee*100}`;

      try {
     
        let response = await axios.post(url, {
          params: {}
        });

        var result = response.data;

        if (result.error == 'no_error') {
          // self.get();
          self.dialog = false;
          self.reload();
        } else {
          alert(result.error);
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ratings " + error);
      }
    },
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
